import { render, staticRenderFns } from "./RobberyHouseSecuredQuestion.vue?vue&type=template&id=d9e62a6c&scoped=true"
import script from "./RobberyHouseSecuredQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyHouseSecuredQuestion.vue?vue&type=script&lang=ts"
import style0 from "./RobberyHouseSecuredQuestion.vue?vue&type=style&index=0&id=d9e62a6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9e62a6c",
  null
  
)

export default component.exports